import { render, staticRenderFns } from "./SiteEdit.vue?vue&type=template&id=48c0bab8&"
import script from "./SiteEdit.vue?vue&type=script&lang=js&"
export * from "./SiteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports